function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect, useCallback, useRef } from 'react';
import { shallowArray } from '@okee-uikit/react-utils';
import { useSelect } from './useSelect';
export function useDisplayInfo(children) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      displayInfo = _useState2[0],
      setDisplayInfo = _useState2[1];

  var select = useSelect();
  var valueCache = useRef([]);
  var displayInfoCache = useRef([]);
  var allDisplayInfoCache = useRef([]);
  var handleChange = useCallback(function (_, info) {
    setDisplayInfo(info.map(function (item) {
      return _objectSpread({}, item);
    }));
  }, []);
  useEffect(function () {
    if (!shallowArray(select.value || [], valueCache.current)) {
      valueCache.current = select.value;
      displayInfoCache.current = select.getDisplayInfo();
      handleChange([], displayInfoCache.current);
    }

    var infos = select.getDisplayInfo();

    if (infos && Array.isArray(infos) && infos.length > 0) {
      displayInfoCache.current = infos;
      handleChange([], infos);
    } else {
      handleChange([], displayInfoCache.current);
    }
  }, [select.value, children]);
  useEffect(function () {
    select.addListener('value-change', handleChange);
    return function () {
      select.removeListener('value-change', handleChange);
    };
  }, [handleChange]);
  var displayInfoObj = {};
  [].concat(_toConsumableArray(allDisplayInfoCache.current), _toConsumableArray(displayInfo)).map(function (info) {
    info && (displayInfoObj[info.value] = info);
  });
  var allDisplayInfo = select.value.map(function (v) {
    return displayInfoObj[v];
  }).filter(function (v) {
    return !!v;
  });
  allDisplayInfoCache.current = allDisplayInfo;
  return {
    displayInfo: displayInfo,
    allDisplayInfo: allDisplayInfo
  };
}